import React, { useState, useEffect, useRef } from "react";
import "../../../../assets/ManageSleeve.css";
import {
  checkEnvelopeCredit,
  checkEnvelopeStorage,
  getEnvelopeSenderList,
  calendarSync,
  checkMyFilesEnabled
} from "../../../../services/CommonService";
import { useNavigate } from "react-router-dom";
import Utils from "../../../../utils";
import Pagination from "react-js-pagination";
import DeleteEnvelope from "./DeleteEnvelope";
import TransferEnvelope from "./TransferEnvelope";
import CopyEnvelope from "./CopyEnvelope";
import AddEnvelopeTemplate from "./AddEnvelopeTemplate";
import { toast } from "react-toastify";
import CheckEnvelopeCredit from "./CheckEnvelopeCredit";
import CheckEnvelopeStorage from "./CheckEnvelopeStorage";
import useDocumentCounts from "./useDocumentCounts";
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';

import { checkCloudIntegration } from "../../../../services/CommonService";

const lengths = Utils.tableShowLengths();

// Helper function to highlight search terms
const highlightSearchTerm = (text, searchTerm) => {
  if (!searchTerm || !text) return text;

  const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? (
      <mark key={index} className="search-highlight" style={{
        backgroundColor: '#ffeb3b',
        padding: '0 2px',
        borderRadius: '2px',
        fontWeight: 'bold'
      }}>
        {part}
      </mark>
    ) : part
  );
};

function ManageEnvelope() {
  const navigate = useNavigate();
  const userData = Utils.loginUserData();
  const userEmail = userData?.email || "";

  const [senderList, setSenderList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [totalData, setTotalData] = useState(0);
  const [dataParams, setDataParams] = useState({
    limit: lengths[0],
    page: 1,
    status_id: 1,
    search: "",
    sender_id: "",
    order_column: 'created_at',
    order_by: false,
    is_effect: false,
  });
  const [deleteEnvelope, setDeleteEnvelope] = useState({ id: 0, name: '' });
  const [copyEnvelope, setCopyEnvelope] = useState(0);
  const [expandedEnvelopes, setExpandedEnvelopes] = useState({});
  const [isGoogleCalendarSynced, setIsGoogleCalendarSynced] = useState(false);
  const [googleCalendarSyncStatus, setGoogleCalendarSyncStatus] = useState({});
  const [myFilesEnabled, setMyFilesEnabled] = useState(null); // <-- add state

  const openCheckEnvelopeRef = useRef(null);
  const openCheckEnvelopeStorageRef = useRef(null);

  const {
    counts: { totalMyFile, totalFiles, totalInProgress, totalDraft, totalCompleted },
    envelopeList,
    envelopeProcess,
    loading,
    setLoading,
    setEnvelopeList,
  } = useDocumentCounts({ userEmail, selectedUserId, dataParams, userId: selectedUserId });

  useEffect(() => {
    getEnvelopeSenderList()
      .then(response => {
        const senderData = response.data.data;
        setSenderList(senderData);
        if (senderData.length > 0) {
          setSelectedUserId(senderData[0].id);
        }
      })
      .catch(err => {
        console.error("Error fetching sender list:", err);
      });
    // Check MyFiles enabled status
    checkMyFilesEnabled({})
      .then(res => {
        if (res.data && typeof res.data.data?.myfiles_enabled !== 'undefined') {
          setMyFilesEnabled(res.data.data.myfiles_enabled);
        } else {
          setMyFilesEnabled(false);
        }
      })
      .catch(err => {
        setMyFilesEnabled(false);
      });
  }, []);


  useEffect(() => {
    setTotalData(totalInProgress);
  }, [totalInProgress])

  const handleData = (e, type) => {
    let params = { ...dataParams };
    if (type === 'pagination') {
      params.page = e;
    } else if (type === 'sender') {
      params.sender_id = e.target.value;
      setSelectedUserId(e.target.value);
    } else if (type === 'search') {
      params.search = e.target.value;
    } else if (type === 'limit') {
      params.limit = parseInt(e.target.value);
    }
    setDataParams(params);
  };

  const onAddEnvelopeTemplate = (e, data) => {
    e.preventDefault();
    setDeleteEnvelope({ id: data.id, name: data.envelope_name });
  };

  const onCopyEnvelope = (e, data) => {
    e.preventDefault();
    setCopyEnvelope(data.id);
  };

  const onDeleteEnvelope = (e, data) => {
    e.preventDefault();
    setDeleteEnvelope({ id: data.id, name: data.envelope_name });
  };

  const onTransferEnvelope = (e, data) => {
    e.preventDefault();
    setDeleteEnvelope({ id: data.id, name: data.envelope_name });
  };

  const handleManageView = (e, data, recipient) => {
    if (parseInt(data.is_credit) === 0) {
      setLoading(true);
      checkEnvelopeCredit({})
        .then(response => {
          setLoading(false);
          if (response.data.is_credit === true) {
            navigate('/manage/' + data.uuid, {
              state: {
                recipient_id: recipient.id,
                recipient_name: recipient.first_name + ' ' + recipient.last_name,
              },
            });
          } else {
            openCheckEnvelopeRef?.current.click();
          }
        })
        .catch(err => {
          setLoading(false);
          toast.error(Utils.getErrorMessage(err));
        });
    } else if (parseInt(data.is_storage_full) === 1) {
      setLoading(true);
      checkEnvelopeStorage({ envelope_id: data.id })
        .then(response => {
          setLoading(false);
          if (response.data.is_storage_full === false) {
            navigate('/manage/' + data.uuid, {
              state: {
                recipient_id: recipient.id,
                recipient_name: recipient.first_name + ' ' + recipient.last_name,
              },
            });
          } else {
            openCheckEnvelopeStorageRef?.current.click();
          }
        })
        .catch(err => {
          setLoading(false);
          toast.error(Utils.getErrorMessage(err));
        });
    } else {
      navigate('/manage/' + data.uuid, {
        state: {
          recipient_id: recipient.id,
          recipient_name: recipient.first_name + ' ' + recipient.last_name,
        },
      });
    }
  };

  const handleManageMessageView = (e, data, recipient, type) => {
    if (parseInt(data.is_credit) === 0) {
      setLoading(true);
      checkEnvelopeCredit({})
        .then(response => {
          setLoading(false);
          if (response.data.is_credit === true) {
            navigate('/manage/' + data.uuid + '/' + type, {
              state: {
                recipient_id: recipient.id,
                recipient_name: recipient.first_name + ' ' + recipient.last_name,
              },
            });
          } else {
            openCheckEnvelopeRef?.current.click();
          }
        })
        .catch(err => {
          setLoading(false);
          toast.error(Utils.getErrorMessage(err));
        });
    } else if (parseInt(data.is_storage_full) === 1) {
      setLoading(true);
      checkEnvelopeStorage({ envelope_id: data.id })
        .then(response => {
          setLoading(false);
          if (response.data.is_storage_full === false) {
            navigate('/manage/' + data.uuid + '/' + type, {
              state: {
                recipient_id: recipient.id,
                recipient_name: recipient.first_name + ' ' + recipient.last_name,
              },
            });
          } else {
            openCheckEnvelopeStorageRef?.current.click();
          }
        })
        .catch(err => {
          setLoading(false);
          toast.error(Utils.getErrorMessage(err));
        });
    } else {
      navigate('/manage/' + data.uuid + '/' + type, {
        state: {
          recipient_id: recipient.id,
          recipient_name: recipient.first_name + ' ' + recipient.last_name,
        },
      });
    }
  };

  const handleCreateSort = (e, column) => {
    e.preventDefault();
    let params = { ...dataParams };
    params.order_column = column;
    params.order_by = !params.order_by;
    params.page = 1;
    setDataParams(params);
  };

  const toggleExpand = (envelopeId) => {
    setExpandedEnvelopes(prev => ({
      ...prev,
      [envelopeId]: !prev[envelopeId],
    }));
  };

  // Helper to update envelopeList's is_calendar_sync
  const updateEnvelopeSyncStatus = (envelopeId, status) => {
    setEnvelopeList(prevList =>
      prevList.map(env =>
        env.id === envelopeId ? { ...env, is_calendar_sync: status } : env
      )
    );
  };

  const onSyncToGoogleCalendar = async (e, item) => {
    if (e && e.preventDefault) e.preventDefault();

    try {
      // Check if Google Calendar is connected
      const integrationRes = await checkCloudIntegration({});
      const isGoogleCalendarConnected = integrationRes?.data?.data?.google_calendar === true;
      if (!isGoogleCalendarConnected) {
        toast.info('Please connect your Google Calendar first.');
        navigate('/settings/integration');
        return;
      }
      // Proceed with sync
      const response = await calendarSync({ envelope_id: Number(item.id) });
      if (response?.data?.message === "sleeve synced successfully") {
        toast.success('Successfully synced to Google Calendar!');
        updateEnvelopeSyncStatus(item.id, true);
      } else {
        toast.error('Failed to sync to Google Calendar. Please try again.');
      }
    } catch (err) {
      toast.error('Failed to sync to Google Calendar. Please try again.');
    }
  };

  const onUnsyncFromGoogleCalendar = async (e, item) => {
    if (e && e.preventDefault) e.preventDefault();
    try {
      // Direct API call for unsync
      const response = await calendarSync({ envelope_id: Number(item.id) });
      if (response?.data?.message === "sleeve unsynced successfully") {
        toast.success('Successfully unsynced from Google Calendar!');
        updateEnvelopeSyncStatus(item.id, false);
      } else {
        toast.error('Failed to unsync from Google Calendar. Please try again.');
      }
    } catch (err) {
      toast.error('Failed to unsync from Google Calendar. Please try again.');
    }
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}
      <section className="section-bg-color min-height-sleeve sleeve-spacing wrapper-sleeve res-height">
        <div className="custom_container">
          {/* <h2 className="mb-2">Sleeves</h2> */}
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className="table_header_wrap">
              <div className="nav nav-tabs wrap_left flexWrap rounded" id="nav-tab" role="tablist">
                <button className="nav-link active mb-3" onClick={(e) => navigate('/manage')} type="button" role="tab" aria-selected="true">
                  In Progress <span>({totalInProgress})</span>
                </button>
                <button className="nav-link mb-3" onClick={(e) => navigate('/manage/draft')} type="button"
                  role="tab" aria-selected="true">
                  Draft <span>({totalDraft})</span>
                </button>
                <button className="nav-link mb-3" onClick={(e) => navigate('/manage/completed')}
                  type="button" role="tab" aria-selected="true">
                  Completed <span>({totalCompleted})</span>
                </button>
                <button className="nav-link d-flex mb-3" onClick={(e) => navigate('/manage/files')}
                  type="button" role="tab" aria-selected="true" >Sleeve Files
                </button>
                {/* My Files Button Logic */}
                {myFilesEnabled && (
                  <button className="nav-link d-flex mb-3" onClick={(e) => navigate('/manage/my-files')}
                    type="button" role="tab" aria-selected="true" >
                    My Files
                  </button>
                )}
              </div>
            </div>
            <div className="filters-container">
              <div className="search-box mb-3">
                <i className="bi bi-search"></i>
                <input
                  type="text"
                  value={dataParams.search} onChange={(e) => handleData(e, 'search')}
                  placeholder="Search Sleeve"
                />
              </div>

              {senderList.length > 1 && (
                <select className="filter-select mb-3" aria-label="Default select example"
                  data-toggle="tooltip"
                  value={dataParams.sender_id} onChange={(e) => handleData(e, 'sender')}
                  data-placement="right" title="">
                  <option value="">Select User</option>
                  {senderList.map((item, index) =>
                    <option key={index}
                      value={item.id}>{item.first_name + " " + item.last_name}</option>
                  )}
                </select>
              )}
            </div>
          </div>

          <div id="nav-tabContent">
            <div className="table-container table-responsive" id="Inprogress-detail" role="tabpanel" aria-labelledby="Inprogress">
              {/* <div className="" > */}
              <table className="table-modern">
                <thead>
                  <tr>
                    <th className="cur-pointer " onClick={(e) => handleCreateSort(e, 'envelope_name')} style={{ minWidth: '180px' }}>
                      Sleeve Name
                    </th>
                    <th className="cur-pointer p-0" onClick={(e) => handleCreateSort(e, 'due_date')} style={{ minWidth: '100px' }}>
                      Due Date
                    </th>
                    <th className="">
                      <div className="table-responsive">
                        <table className="w-100 inner_table_head border-0">
                          <thead>
                            <tr>
                              <th className="p-0 th-width-200 border-0">Recipients</th>
                              <th style={{ minWidth: '100px' }} className="border-0 p-0">
                                Awaiting
                              </th>
                              <th style={{ minWidth: '130px' }} className="border-0 p-0">
                                Needs Review
                              </th>
                              <th style={{ minWidth: '110px' }} className=" p-0 border-0">
                                Approved
                              </th>
                              <th style={{ minWidth: '140px' }} className="p-0 border-0">
                                Messages
                              </th>
                              <th style={{ minWidth: '100px' }} className="p-0 border-0">Action</th>
                            </tr>
                          </thead>
                        </table>
                      </div>
                    </th>
                    <th style={{ width: '40px' }} className="text-center">
                      <i className="bi bi-three-dots-vertical" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {envelopeList.map((item, index) => {
                    const isExpanded = expandedEnvelopes[item.id] || false;
                    const recipientsToShow = isExpanded ? item.recipient_list : item.recipient_list.slice(0, 1);
                    const hasMoreRecipients = item.recipient_list.length > 1;

                    return (
                      <tr key={index} className={item.is_smart_sleeve ? 'smart-sleeve-row' : ''} style={{ minWidth: '180px' }}>
                        <td>
                          <div className="Recipients_name" bis_skin_checked="1">
                            <span className="text_blue fw_bold pt_10 d-inline-flex align-items-center">
                              {highlightSearchTerm(item.envelope_name, dataParams.search)}
                              {item.is_smart_sleeve && (
                                <span
                                  className="smart-sleeve-badge ms-2"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Smart Sleeve"
                                >
                                  <i className="bi bi-lightning-fill"></i>Smart
                                </span>
                              )}
                            </span>
                            <div className="d-flex">
                              <span className="me-2">{highlightSearchTerm(item.sender_name, dataParams.search)}</span>
                              <span>({item.created_at})</span>
                            </div>
                          </div>
                        </td>
                        <td className="p-0" style={{ minWidth: '100px' }}>
                          <span className="pt_10 d-block">{item.due_date}</span>
                        </td>
                        <td className="p-0">
                          <table className="table-modern">
                            <tbody>
                              {recipientsToShow.map((recipient, r) => (
                                <tr key={r} className="sub-table-row">
                                  <td className="td-width-200 p-0">
                                    <div className="recipient-cell ms-1">
                                      <span>{highlightSearchTerm(recipient.first_name + ` ` + recipient.last_name, dataParams.search)}</span>
                                      {r === 0 && hasMoreRecipients && (
                                        <button
                                          className="show-more-badge ms-2"
                                          onClick={() => toggleExpand(item.id)}
                                          aria-expanded={isExpanded}
                                          aria-label={isExpanded ? "Show less recipients" : `Show more recipients`}
                                        >
                                          +{item.recipient_list.length - 1} <i className="bi bi-chevron-down ms-1" />
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                  <td style={{ minWidth: '100px', textAlign: "center" }} className=" p-0">
                                    <span
                                      onClick={(e) => handleManageMessageView(e, item, recipient, 'awaiting')}
                                      className="needs_review cur-pointer ">{recipient.awaiting}</span>
                                  </td>
                                  <td style={{ minWidth: '130px', textAlign: "center" }} className=" p-0">
                                    <span
                                      onClick={(e) => handleManageMessageView(e, item, recipient, 'needs-review')}
                                      className="needs_review bg_light_blue cur-pointer">{recipient.need_review}</span>
                                  </td>
                                  <td className="p-0" style={{ minWidth: '110px' }}>
                                    <div
                                      onClick={(e) => handleManageMessageView(e, item, recipient, 'approved')}
                                      className={`progress-circle cur-pointer p-0 ${recipient.percentage > 50 ? `over50` : ``} p${recipient.percentage}`}>
                                      <span>{recipient.approved}/{recipient.total_envelope}</span>
                                      <div className="left-half-clipper">
                                        <div className="first50-bar" />
                                        <div className="value-bar" />
                                      </div>
                                    </div>
                                  </td>
                                  <td style={{ minWidth: '140px' }} className="text-center">
                                    <div className="mesage_notification"
                                      onClick={(e) => handleManageMessageView(e, item, recipient, 'message')}>
                                      <i className="bi bi-chat-fill" aria-hidden="true">
                                        {recipient.is_message === true && (
                                          <span className="red_dot" />
                                        )}
                                      </i>
                                    </div>
                                  </td>
                                  <td style={{ minWidth: '100px' }}>
                                    <span className="Action_perform" data-toggle="tooltip"
                                      data-placement="right" title=""
                                      onClick={(e) => handleManageView(e, item, recipient)}
                                      data-bs-original-title="Manage Your sleeve">Manage</span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>
                        <td className="table-header-center">
                          <div className="sleeve-dropdown">
                            <Dropdown
                              trigger={['click']}
                              overlay={
                                <Menu className="custom-rc-dropdown-menu">
                                  {!item.is_smart_sleeve && (
                                    <>
                                      <MenuItem
                                        key="add-template"
                                        className="custom-rc-dropdown-item"
                                        onClick={() => onAddEnvelopeTemplate({ preventDefault: () => { } }, item)}
                                        data-bs-toggle="modal"
                                        data-bs-target="#AddEnvelopeTemplate"
                                      >
                                        <i className="bi bi-plus-circle" /> Add to Templates
                                      </MenuItem>
                                      <MenuItem
                                        key="duplicate"
                                        className="custom-rc-dropdown-item"
                                        onClick={() => onCopyEnvelope({ preventDefault: () => { } }, item)}
                                        data-bs-toggle="modal"
                                        data-bs-target="#CopyEnvelope"
                                      >
                                        <i className="bi bi-files" /> Duplicate Sleeve
                                      </MenuItem>
                                    </>
                                  )}

                                  <MenuItem
                                    key="transfer"
                                    className="custom-rc-dropdown-item"
                                    onClick={() => onTransferEnvelope({ preventDefault: () => { } }, item)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#transferEnvelope"
                                  >
                                    <i className="bi bi-arrow-left-right" /> Transfer Sleeve
                                  </MenuItem>
                                  {item.is_calendar_sync === false ? (
                                    <MenuItem
                                      key="sync-google-calendar"
                                      className="custom-rc-dropdown-item"
                                      onClick={() => onSyncToGoogleCalendar({ preventDefault: () => { } }, item)}
                                    >
                                      <i className="bi bi-calendar-check-fill"></i> Sync to Google Calendar
                                    </MenuItem>
                                  ) : (
                                    <MenuItem
                                      key="unsync-google-calendar"
                                      className="custom-rc-dropdown-item"
                                      onClick={() => onUnsyncFromGoogleCalendar({ preventDefault: () => { } }, item)}
                                    >
                                      <i className="bi bi-calendar2-x-fill"></i> Unsync to Google Calendar
                                    </MenuItem>
                                  )}
                                  <MenuItem
                                    key="delete"
                                    className="custom-rc-dropdown-item-delete custom-rc-dropdown-item"
                                    onClick={() => onDeleteEnvelope({ preventDefault: () => { } }, item)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#DeleteEnvelope"
                                  >
                                    <i className="bi bi-trash" /> Delete Sleeve
                                  </MenuItem>
                                </Menu>
                              }
                              animation="slide-up"
                            >
                              <button className="dots-button">
                                <i className="bi bi-three-dots-vertical"></i>
                              </button>
                            </Dropdown>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                  {envelopeList.length === 0 && (
                    <tr>
                      <td className="text-center" colSpan={9}>{envelopeProcess}</td>
                    </tr>
                  )}
                </tbody>
              </table>
              {/* </div> */}
            </div>
          </div>
          {totalData > dataParams.limit && (
            <div className="table_footer_wrap">
              <div className="d-flex align-items-center mb-4">
                <span className="me-2 text-white">Show</span>
                <select className="form-select" value={dataParams.limit} style={{ width: "80px" }}
                  onChange={(e) => handleData(e, 'limit')} aria-label="Default select example">
                  {lengths && lengths.map((item, i) => <option value={item} key={i}>{item}</option>)}
                </select>
              </div>

              <div className="pagination mb-4">
                <Pagination
                  activePage={dataParams.page}
                  itemsCountPerPage={dataParams.limit}
                  totalItemsCount={totalData}
                  pageRangeDisplayed={5}
                  onChange={(e) => handleData(e, 'pagination')}
                />
              </div>
            </div>
          )}
        </div>

        <DeleteEnvelope deleteEnvelope={deleteEnvelope} setDeleteEnvelope={setDeleteEnvelope}
          setLoading={setLoading} dataParams={dataParams} setDataParams={setDataParams} />

        <AddEnvelopeTemplate deleteEnvelope={deleteEnvelope} setDeleteEnvelope={setDeleteEnvelope}
          setLoading={setLoading} />

        <TransferEnvelope deleteEnvelope={deleteEnvelope} setDeleteEnvelope={setDeleteEnvelope}
          senderList={senderList} setLoading={setLoading} dataParams={dataParams}
          setDataParams={setDataParams} />

        <CopyEnvelope copyEnvelope={copyEnvelope} setCopyEnvelope={setCopyEnvelope}
          setLoading={setLoading} />
      </section >

      <span data-bs-toggle="modal" data-bs-target="#checkEnvelopeCredit" ref={openCheckEnvelopeRef} />
      <span data-bs-toggle="modal" data-bs-target="#checkEnvelopeStorage" ref={openCheckEnvelopeStorageRef} />
      <CheckEnvelopeCredit />
      <CheckEnvelopeStorage />
    </>
  );
}

export default ManageEnvelope;